const APP_STORE_URL = "https://apps.apple.com/us/app/ar-labs-io/id1586984187";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.sensilabs.clickfitapp&hl=en&gl=US&pli=1";

export { APP_STORE_URL, PLAY_STORE_URL };
